// extracted by mini-css-extract-plugin
export default {"About":"About_About__eFhYK","About__header":"About_About__header__h9UHn","About__content":"About_About__content__YVIpW","butt":"About_butt__MWEIY","a":"About_a__m3tDx"};